var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s_title flex flex-direction"},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('img',{staticClass:"title-border",attrs:{"src":require("../../../assets/images/guide/title-border.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }